<template>


    <section class="">

        <div class="">
            <div class="grid grid-cols-12 bg-lifeboost-red-lighter gap-x-8">
                <div class="items-center md:col-span-7 col-span-12 px-4 bg xl:ml-[calc((100vw_-_1280px)_/_2)] grid">


                    <div class="py-8 md:py-20 lg:py-0 lg:pr-10">
                        <h3 class="mb-4 font-bold h2 lg:max-w-xl">
                            Get The Best Single Origin Coffee Beans In our top selling flavors!

                        </h3>

                        <p class="font-bold h4">
                            Act Now As We Have A VERY Limited Supply
                        </p>

                        <div class="grid grid-cols-1 mt-8 sm:grid-cols-2 gap-y-10 lg:gap-x-8 md:gap-x-4 gap-x-8">
                            <div class="grid items-start grid-cols-12" v-for="(item, index) in items" :key="index">
                                <div class="col-span-2 sm:col-span-3 md:col-span-3">
                                    <nuxt-img width="62" height="62" format="webp" :src="item.src" :alt="item.alt"
                                        class="object-cover" loading="lazy" />
                                </div>

                                <p class="col-span-9 pl-4 textp lg:col-span-9 md:col-span-8 xl:pl-0">
                                    {{ item.description }}
                                </p>
                            </div>
                        </div>


                    </div>

                </div>
                <div class="grid items-center col-span-12 my-16 md:col-span-5">
                    <nuxt-img width="494" height="529" format="webp" src="/assets/images/cookie-coffee.png"
                        alt="section image" class="object-cover mx-auto mix-blend-multiply" loading="lazy" sizes="xs:330px sm:440px md:745vw lg:388px xl:494" />



                </div>
            </div>
        </div>
    </section>


</template>

<script setup>

const items = ref([
    {
        src: '/assets/images/Group-icon-1.png',
        alt: 'section image',
        description: 'Organic Medium Roast Coffee Beans (Specialty Arabica Beans)'
    },
    {
        src: '/assets/images/Group-icon-2.png',
        alt: 'section image',
        description: 'Single Origin From Small Farms In A Nationally Protected Area'
    },
    {
        src: '/assets/images/Group-icon-3.png',
        alt: 'section image',
        description: 'Shade And Elevation Grown (Slow Grown In The Mountains Of Nicaragua For Optimal Flavor And Low Acidity)'
    },
    {
        src: '/assets/images/Group-icon-4.png',
        alt: 'section image',
        description: 'Fairly Traded (Our Coffee Farmers Are Paid A Fair Wage)'
    }
])

defineBuilderComponent({
    friendlyName: 'TextIconsImage',
    ignored: true
})
</script>